"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function noop() { }
exports.default = noop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-media/lib/utilities/noop.js
// module id = 1301
// module chunks = 0